import React from "react"
import { useDispatch } from 'react-redux'
import { FightSegmentList } from 'web/components/fight-segments/FightSegmentList'
import { FightHeader } from 'web/components/shared/FightHeader'
import { getFightCategoryLabelById } from 'web/data/gui-data'
import { FullFight, FightSetup } from 'web/data/models'
import { InteractivityActions, useInteractivitySelectors } from 'web/redux/slices/interactivity-slice'
import { decorateNameWithOrdinal } from 'web/utils/text-utils'
import { createEventAssignmentsCallback } from '../shared/utils'

type Props = {
    fullFight: FullFight
    selectedSetup?: FightSetup
}

export const DisplayFightContainer: React.FC<Props> = ({
    fullFight,
    selectedSetup
}) => {

    const disp = useDispatch()
    const interactivitySelectors = useInteractivitySelectors()

    const activeFight = fullFight.fight

    const eventAssignmentsCallback = createEventAssignmentsCallback({
        fullFight: fullFight,
        selectedSetup: selectedSetup,
        onHoverEnter: (({ setupId, availableEventIds }) => {
            disp(InteractivityActions.setAvailableEventIdsForSetup({
                setupId,
                availableEventIds
            }))
        }),
        onHoverLeave: ({ setupId }) => {
            disp(InteractivityActions
                .clearAvailableEventIdsForSetup({ setupId }))
        }
    })

    return (
        <div className="d-flex space-mx-3">
            <div className="pr-3" style={{ width: "650px" }}>
                <FightHeader
                    categoryName={getFightCategoryLabelById(activeFight.categoryId)}
                    fightName={activeFight.name}
                    fightNoteHtml={activeFight.note}
                    hideNote={false}
                    className="mb-3"
                />

                <div className="space-my-3">
                    <FightSegmentList
                        segments={fullFight.segments}
                        events={fullFight.events}
                        segmentProps={{
                            decorateNameWithOrdinal: (event) => {
                                return decorateNameWithOrdinal(fullFight.events, event)
                            },

                            eventProps: {
                                assignments: {
                                    eventAssignments: eventAssignmentsCallback
                                },
                                interactive: {
                                    extraClassNames: (eventId: string) => {
                                        if (selectedSetup == null) {
                                            return undefined
                                        }

                                        const eventState = interactivitySelectors
                                            .getEventStateForSetup(selectedSetup.id, eventId)

                                        if (eventState.valid) {
                                            return "bg-light-green"
                                        } else if (eventState.invalid) {
                                            return "bg-light-red"
                                        }
                                    }
                                }
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    )
}


